module.exports = __webpack_public_path__ + "./fonts/Poppins_900Black.ttf";